// extracted by mini-css-extract-plugin
export var content = "Slide-module--content--3c7e1";
export var organisers = "Slide-module--organisers--c14da";
export var picture = "Slide-module--picture--32c0a";
export var img = "Slide-module--img--96b2b";
export var textWrapper = "Slide-module--textWrapper--f5e54";
export var nameMobile = "Slide-module--nameMobile--2d841";
export var name = "Slide-module--name--0ff7f";
export var countryMobile = "Slide-module--countryMobile--c59ac";
export var country = "Slide-module--country--086ac";
export var paragraphs = "Slide-module--paragraphs--00314";
export var text = "Slide-module--text--b0074";